import type { IconType } from '../../../../theme/themes/ThemeTypes';

export const Help: IconType = ({ colour, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={43} height={42} fill="none" {...props}>
    <path
      stroke={colour}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15.067 17.068c0-1.234.339-2.432 1.004-3.485a6.49 6.49 0 0 1 2.698-2.408 6.605 6.605 0 0 1 3.57-.605 6.414 6.414 0 0 1 3.339 1.392 6.512 6.512 0 0 1 2.08 2.964 6.58 6.58 0 0 1 .194 3.618 6.519 6.519 0 0 1-1.766 3.158 6.437 6.437 0 0 1-3.182 1.73c-.4.073-.75.29-1.004.593-.255.314-.4.702-.412 1.1v1.937"
    />
    <path
      stroke={colour}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21.588 41c11.047 0 20-8.953 20-20s-8.953-20-20-20c-11.046 0-20 8.953-20 20s8.954 20 20 20Z"
    />
    <path
      stroke={colour}
      strokeWidth={2}
      d="M21.588 32.289a.434.434 0 0 1-.435-.436c0-.242.193-.436.435-.436M21.588 32.289a.434.434 0 0 0 .436-.436.434.434 0 0 0-.436-.436"
    />
  </svg>
);
